export default "__VITE_ASSET__DPZDoZEc__"